<template>
    <div id="app" class="clear">
        <img class="logoo" src="./assets/logoo.png" alt="">
        <div class="wrap">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide one" alt="">
                        <img
                            v-for="item in oneImg"
                            :class="item.className"
                            :data-src="item.img"
                            :swiper-animate-duration="item.swiperAnimateDuration"
                            :swiper-animate-effect="item.swiperAnimateEffect"
                            :key="item.img"
                            alt=""
                        />
                        <div class="circle ani"></div>
                        <div class="copyright_pc">Copyright © 1998 - 2023 Tencent. All Rights Reserved</div>
                        <div class="copyright_mb">Copyright © 1998 - 2023 Tencent. All Rights Reserved</div>
                    </div>
                    <div class="swiper-slide two" alt="">
                        <img
                            v-for="i in imgs"
                            :class="[i.className,i.names]"
                            :src="i.img"
                            swiper-animate-effect="fadeInUp"
                            swiper-animate-duration="1s"
                            :key="i.img"
                            alt=""
                        />
                        <div class="copyright_pc">Copyright © 1998 - 2023 Tencent. All Rights Reserved</div>
                        <div class="copyright_mb">Copyright © 1998 - 2023 Tencent. All Rights Reserved</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import animate from 'script-loader!./js/swiper.animate.min.js';
import $ from 'jquery';

export default {
  name: 'app',
  data() {
    return {
      names: 'ani',
      imgs: [
        { img: require('./assets/join_big.png'), className: 'join', names: 'ani' },
        { img: require('./assets/join_small.png'), className: 'join2', names: 'ani' },
        { img: require('./assets/line.png'), className: 'line1', names: 'ani' },
        { img: require('./assets/word_small.png'), className: 'join_content', names: 'ani' },
        { img: require('./assets/word_big.png'), className: 'join_content2', names: 'ani' },
        { img: require('./assets/cooperation_big.png'), className: 'cooperation', names: 'ani' },
        { img: require('./assets/cooperation_small.png'), className: 'cooperation2', names: 'ani' },
        { img: require('./assets/line.png'), className: 'line2', names: 'ani' },
        { img: require('./assets/web_carlogo.png'), className: 'car_brands', names: 'ani' },
        { img: require('./assets/phone_carlogo.png'), className: 'car_brands2', names: 'ani' },
      ],
      count: 0,
      show: false,
      oneImg: [
        { img: require('./assets/BG.png'), className: 'bg img_pc', names: 'ani' },
        { img: require('./assets/gb.gif'), className: 'gb_gif img_pc', names: 'ani' },
        { img: require('./assets/BG_web.png'), className: 'bg_web img_mb', names: 'ani' },
        { img: require('./assets/web_gif1.gif'), className: 'web_gif img_mb', names: 'ani' },
        { img: require('./assets/logo.png'), className: 'logo ani img_pc img_mb', names: 'ani',  swiperAnimateDuration: '1s', swiperAnimateEffect: 'fadeInUp' },
        { img: require('./assets/web_slogan.png'), className: 'slogan ani img_pc', names: 'ani',  swiperAnimateDuration: '1s', swiperAnimateEffect: 'fadeInUp' },
        { img: require('./assets/phone_slogan.png'), className: 'slogan2 ani img_mb', names: '',  swiperAnimateDuration: '1s', swiperAnimateEffect: 'fadeInUp' },
        { img: require('./assets/18ss.gif'), className: 'arrow img_mb img_pc', names: '' },
      ],
    };
  },
  // methods: {
  //     loadImg() {
  //         var img = new Image();
  //         img.onload = () => {
  //             this.oneGifUrl = 'http://localhost:8082/dist/one.gif?4c874630404993a6748ca2effc06206a';
  //             setTimeout(() => {
  //                 document.querySelector('#img').style.opacity = 0;
  //             }, 5000)
  //         }
  //         img.src = 'src/assets/one.gif';
  //     }
  // },
  mounted() {
    // alert(document.documentElement.clientWidth)
    const imgs = document.documentElement.clientWidth < 640 ? document.querySelectorAll('.img_mb') : document.querySelectorAll('.img_pc');
    for (let i = 0; i < imgs.length; i++) {
      const $img = $(imgs[i]);
      // console.log(  $img );
      $img.attr('src', $img.data('src'));
    }

    /* var _this = this;
        let imgs = document.querySelectorAll('#img')
        console.log(imgs)
        Array.from(imgs).forEach((item)=>{
            let img = new Image();
            img.onload = ()=>{
                this.count++;
            }
            img.src=item.getAttribute('src')
        });

        console.log($(".one_gif").attr("src"));
        if(window.screen.width < 640){
            $(".one_gif").attr("src", "/static/img/gif5.gif");
        } else {

        }*/
    /* var _this = this
        let imgs = document.querySelectorAll('img')
        console.log(imgs)
        Array.from(imgs).forEach((item)=>{
            let img = new Image()
            img.onload = ()=>{
                this.count++
            }
            img.src=item.getAttribute('src')
        });*/
    setTimeout(() => {
      const swiper = new Swiper('.swiper-container', {
        onInit(swiper) { // Swiper2.x的初始化是onFirstInit
          swiperAnimateCache(swiper); // 隐藏动画元素
          swiperAnimate(swiper); // 初始化完成开始动画
        },
        onSlideChangeEnd(swiper) {
          swiperAnimate(swiper); // 每个slide切换结束时也运行当前slide动画
        },
        pagination: '.swiper-pagination',
        direction: 'vertical',
        speed: 1000,
        slidesPerView: 1,
        paginationClickable: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction: false,
      });
    }, 200);
  }, /* ,
    watch : {
        count (val,oldval) {
            if(val == 3){
                this.show = true
            }
        }
    }*/
};
</script>



// WEBPACK FOOTER //
// src/App.vue